import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/ListManagedThemesPublic/ListManagedThemesPublic";
const endpoints = {
    global: "https://theme.fromsmash.co",
};
config.setHosts("theme", endpoints, false);
export class Theme extends Client {
    constructor(params = {}) {
        super({ service: "theme", ...params, type: "global", userAgent: "@smash-sdk/theme@1.0.0-alpha.7" });
        this.errors = errors;
    }
    listManagedThemesPublic() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/managedThemes/public",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "04-2024",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListManagedThemesPublicError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Theme.errors = errors;
